/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const esESRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Solicitud para añadir escuela',
    description: 'Complete el siguiente formulario. No se garantiza que las escuelas enviadas se añadan, pero SheerID investiga y considera todas las solicitudes. ',
    noCountry: '¿No ve el país de su escuela? Usted no reúne los requisitos para esta oferta.',
    searchByOrgName: '¿No ve su escuela? Buscar por el nombre.',
    completeRequest: '¿No ve su escuela en la lista de escuelas que cumplen, o no, con los requisitos? Complete su solicitud',
    submit: 'Enviar',
    eligibleOrgs: 'Escuelas que reúnen los requisitos. Haga clic en el ícono para copiar el nombre y luego regrese al formulario de verificación.',
    ineligibleOrgs: 'Escuelas que no reúnen los requisitos. Lo sentimos, los estudiantes de estas escuelas no reúnen los requisitos para esta oferta.',
    none: 'Ninguna',
    country: '¿A qué escuela asistes?',
    changeLanguage: 'Cambiar idioma',
    copied: 'Copiado',
    firstName: 'Nombre',
    lastName: 'Apellido',
    emailAddress: 'Correo electrónico',
    poweredBy: 'Servicios de verificación con tecnología de SheerID.',
    fields: {
        countryPlaceholder: 'Seleccione el país',
        domainLabel: 'Sitio web de la escuela',
        domainPlaceholder: 'www.miescuela.es',
        orgNameLabel: 'Nombre de la escuela',
        orgNamePlaceholder: 'Mi escuela',
    },
    step: {
        success: {
            title: 'Gracias por enviar su solicitud de escuela',
            description: 'Se recuerda que SheerID evalúa cada solicitud en relación con los requisitos establecidos para esta oferta. No se garantiza que su centro educativo se vaya a añadir. El proceso de evaluación puede tardar hasta 7 días en completarse.',
        },
        error: {
            title: 'Se produjo un error inesperado.',
            description: 'Lo sentimos, no podemos procesar su solicitud. Inténtelo de nuevo más tarde.',
            seeingProblem: 'Si este problema persiste,',
            contactUs: 'comuníquese con nosotros.',
        },
    },
    errorId: {
        invalidCountry: 'El campo es obligatorio',
        invalidEmail: 'Correo electrónico no válido',
        invalidFirstName: 'Nombre no válido',
        invalidLastName: 'Apellido no válido',
        requiredField: 'El campo es obligatorio',
        invalidField: 'El campo no es válido',
        invalidUrl: 'URL no válida',
        tooManyResults: 'Su búsqueda produjo demasiados resultados, refine su búsqueda e intente nuevamente.',
    },
    faq: 'Preguntas frecuentes sobre la solicitud de SheerID para agregar escuelas',
    countries: {
        AD: 'Andorra',
        AE: 'Emiratos Árabes Unidos',
        AF: 'Afganistán',
        AG: 'Antigua y Barbuda',
        AI: 'Anguila',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Antillas Holandesas',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'Samoa Americana',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbaiyán',
        BA: 'Bosnia-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Bélgica',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahréin',
        BI: 'Burundi',
        BJ: 'Benín',
        BM: 'islas Bermudas',
        BN: 'Brunéi Darussalam',
        BO: 'Bolivia',
        BR: 'Brasil',
        BS: 'Bahamas',
        BT: 'Bután',
        BV: 'Isla Bouvet',
        BW: 'Botsuana',
        BY: 'Bielorrusia',
        BZ: 'Belice',
        CA: 'Canadá',
        CD: 'República Democrática del Congo',
        CF: 'República Centroafricana',
        CG: 'Congo',
        CH: 'Suiza',
        CI: 'Costa de Marfil (Côte D\'Ivoire)',
        CK: 'Islas Cook',
        CL: 'Chile',
        CM: 'Camerún',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cabo Verde',
        CY: 'Chipre',
        CZ: 'Republica Checa',
        DE: 'Alemán',
        DJ: 'Djibouti',
        DK: 'Dinamarca',
        DM: 'Dominica',
        DO: 'República Dominicana',
        DZ: 'Argelia',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egipto',
        EH: 'Sahara Occidental',
        ER: 'Eritrea',
        ES: 'España',
        ET: 'Etiopía',
        FI: 'Finlandia',
        FJ: 'Fiyi',
        FK: 'Islas Malvinas',
        FM: 'Micronesia',
        FO: 'Islas Faroe',
        FR: 'Francia',
        GA: 'Gabón',
        GB: 'Reino Unido',
        GD: 'Granada',
        GE: 'Georgia',
        GF: 'Guayana Francesa',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Groenlandia',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadalupe (francés)',
        GQ: 'Guinea Ecuatorial',
        GR: 'Grecia',
        GS: 'Islas Georgia del Sur y Sandwich del Sur',
        GT: 'Guatemala',
        GU: 'Guam (EE. UU.)',
        GW: 'Guinea Bissau',
        GY: 'Guayana',
        HK: 'Hong Kong',
        HM: 'Islas Heard y McDonald',
        HN: 'Honduras',
        HR: 'Croacia',
        HT: 'Haití',
        HU: 'Hungría',
        ID: 'Indonesia',
        IE: 'Irlanda',
        IL: 'Israel',
        IN: 'India',
        IO: 'Territorio Británico del Océano Índico',
        IQ: 'Irak',
        IR: 'Irán',
        IS: 'Islandia',
        IT: 'Italia',
        JM: 'Jamaica',
        JO: 'Jordán',
        JP: 'Japón',
        KE: 'Kenia',
        KG: 'Kirguistán',
        KH: 'Camboya',
        KI: 'Kiribati',
        KM: 'Comoras',
        KN: 'Saint Kitts y Nevis Anguila',
        KP: 'Corea del Norte',
        KR: 'Corea del Sur',
        KW: 'Kuwait',
        KY: 'Islas Caimán',
        KZ: 'Kazajstán',
        LA: 'Laos',
        LB: 'Líbano',
        LC: 'Santa Lucía',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesoto',
        LT: 'Lituania',
        LU: 'Luxemburgo',
        LV: 'Letonia',
        LY: 'Libia',
        MA: 'Marruecos',
        MC: 'Mónaco',
        MD: 'Moldavia',
        ME: 'Montenegro',
        MG: 'Madagascar',
        MH: 'Islas Marshall',
        MK: 'Macedonia',
        ML: 'Malí',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macao',
        MP: 'Islas Marianas del Norte',
        MQ: 'Martinica (francesa)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauricio',
        MV: 'Maldivas',
        MW: 'Malawi',
        MX: 'México',
        MY: 'Malasia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'Nueva Caledonia (francesa)',
        NE: 'Níger',
        NF: 'Isla Norfolk',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Países Bajos',
        NO: 'Noruega',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nueva Zelanda',
        OM: 'Omán',
        PA: 'Panamá',
        PE: 'Perú',
        PF: 'Polinesia (francesa)',
        PG: 'Papúa Nueva Guinea',
        PH: 'Filipinas',
        PK: 'Pakistán',
        PL: 'Polonia',
        PM: 'San Pedro y Miquelón',
        PN: 'Isla Pitcairn',
        PR: 'Puerto Rico',
        PS: 'Palestina',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunión (francesa)',
        RO: 'Rumanía',
        RS: 'Serbia',
        RU: 'Federación Rusa',
        RW: 'Ruanda',
        SA: 'Arabia Saudita',
        SB: 'Islas Salomón',
        SC: 'Seychelles',
        SD: 'Sudán',
        SE: 'Suecia',
        SG: 'Singapur',
        SH: 'Santa Elena',
        SI: 'Eslovenia',
        SK: 'República Eslovaca',
        SL: 'Sierra Leona',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        SS: 'Sudán del Sur',
        ST: 'Santo Tomé (São Tomé) y Príncipe',
        SV: 'El Salvador',
        SY: 'Siria',
        SZ: 'Swazilandia',
        TC: 'Islas Turcas y Caicos',
        TD: 'Chad',
        TF: 'Territorios Franceses del Sur',
        TG: 'Togo',
        TH: 'Tailandia',
        TJ: 'Tayikistán',
        TK: 'Tokelau',
        TL: 'Timor-Leste',
        TM: 'Turkmenistán',
        TN: 'Túnez',
        TO: 'Tonga',
        TR: 'Turquía',
        TT: 'Trinidad y Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwán',
        TZ: 'Tanzania',
        UA: 'Ucrania',
        UG: 'Uganda',
        UM: 'Islas periféricas menores de EE. UU.',
        US: 'Estados Unidos',
        UY: 'Uruguay',
        UZ: 'Uzbekistán',
        VA: 'Estado de la Ciudad del Vaticano',
        VC: 'San Vicente y Granadinas',
        VE: 'Venezuela',
        VG: 'Islas Vírgenes Británicas',
        VI: 'Islas Vírgenes (EE. UU.)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Islas Wallis y Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'Sudáfrica',
        ZM: 'Zambia',
        ZW: 'Zimbabue',
    },
    locales: {
        ar: 'árabe',
        bg: 'búlgaro',
        cs: 'checo',
        da: 'danés',
        de: 'alemán',
        el: 'griego',
        'en-GB': 'inglés (Reino Unido)',
        'en-US': 'inglés',
        'es-ES': 'español (españa)',
        es: 'español',
        fi: 'finlandés',
        'fr-CA': 'francés (Canadá)',
        fr: 'francés',
        hr: 'croata',
        hu: 'húngaro',
        id: 'indonesio',
        is: 'islandés',
        it: 'italiano',
        iw: 'hebreo',
        ja: 'japonés',
        ko: 'coreano',
        lt: 'lituano',
        ms: 'malayo',
        nl: 'neerlandés',
        no: 'noruego',
        pl: 'nolaco',
        'pt-BR': 'portugués',
        pt: 'portugués (Brasil)',
        ro: 'rumano',
        ru: 'Rusia',
        sk: 'eslovaco',
        sl: 'esloveno',
        sr: 'serbio',
        sv: 'sueco',
        tr: 'turco',
        'zh-HK': 'chino (Hong Kong)',
        zh: 'chino (tradicional)',
    },
};
